/* ══════════════════════════════════════════════════════════════════════════
   ALIA · GUEST LIST — single app script (Route B)
   ALL JavaScript for the theme lives here. Loaded with `defer`, after the
   pinned CDN libraries (gsap 3.13.0 + ScrollTrigger + SplitText, lenis 1.3.4),
   which are also `defer` so execution order is guaranteed.

   ONE Lenis instance drives scroll, synced to ONE ScrollTrigger registry that
   spans every section. Nothing is fragmented per-section: sections only
   REGISTER their triggers/tweens/timers into the shared registry so the theme
   editor can inject, reorder and reload them without stacking duplicates.
   ══════════════════════════════════════════════════════════════════════════ */
(function () {
  "use strict";

  var HAS_GSAP = typeof gsap !== "undefined";
  var HAS_ST = typeof ScrollTrigger !== "undefined";
  var HAS_SPLIT = typeof SplitText !== "undefined";
  var HAS_LENIS = typeof Lenis !== "undefined";
  var REDUCE = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var IS_TOUCH = window.matchMedia("(hover: none), (pointer: coarse)").matches;
  var DPR = Math.min(window.devicePixelRatio || 1, 2);
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var lerp = function (a, b, t) { return a + (b - a) * t; };
  var pad2 = function (n) { n = Math.floor(n); return n < 10 ? "0" + n : "" + n; };

  if (HAS_GSAP && HAS_ST) { gsap.registerPlugin(ScrollTrigger); }
  if (HAS_GSAP && HAS_SPLIT) { try { gsap.registerPlugin(SplitText); } catch (e) {} }

  /* The hero's drifting background reads the SAME lines the book renders, so
     the two never disagree and nothing is invented in either place. Falls back
     only if the book section is not on the page. */
  var DEFAULT_ENTRIES = [
    "FULL BUYOUT", "DAY EVENT", "YEAR-END PARTY",
    "PRODUCT LAUNCH", "COCKTAIL RECEPTION", "THE TERRACE"
  ];
  function ledgerPool() {
    var list = $$("#ledgerRows .l-name").map(function (el) {
      return (el.getAttribute("data-text") || el.textContent || "").trim();
    }).filter(Boolean);
    return list.length ? list : DEFAULT_ENTRIES;
  }

  /* ══════════════════════════════════════════════════════════════════════
     SECTION REGISTRY — trap (H)
     Every ScrollTrigger / tween / timeline / matchMedia / interval / observer
     / listener is filed under the section id that created it, so a reload
     kills exactly that section's own and nothing else.
     ══════════════════════════════════════════════════════════════════════ */
  var REG = Object.create(null);

  function bag(sid) {
    return REG[sid] || (REG[sid] = { sts: [], tweens: [], mms: [], timers: [], ios: [], undo: [] });
  }
  /* file a tween (and its ScrollTrigger, if it made one) under a section */
  function own(sid, tween) {
    if (!tween) return tween;
    var b = bag(sid);
    b.tweens.push(tween);
    if (tween.scrollTrigger) b.sts.push(tween.scrollTrigger);
    return tween;
  }
  function ownST(sid, st) { if (st) bag(sid).sts.push(st); return st; }
  function ownMM(sid, mm) { if (mm) bag(sid).mms.push(mm); return mm; }
  function ownTimer(sid, id) { bag(sid).timers.push(id); return id; }
  function ownIO(sid, io) { if (io) bag(sid).ios.push(io); return io; }
  function ownUndo(sid, fn) { if (fn) bag(sid).undo.push(fn); return fn; }
  function ownListener(sid, target, type, fn, opts) {
    target.addEventListener(type, fn, opts);
    ownUndo(sid, function () { target.removeEventListener(type, fn, opts); });
    return fn;
  }

  function killSection(sid) {
    var b = REG[sid];
    if (!b) return;
    b.undo.forEach(function (fn) { try { fn(); } catch (e) {} });
    b.ios.forEach(function (io) { try { io.disconnect(); } catch (e) {} });
    b.timers.forEach(function (id) { clearTimeout(id); clearInterval(id); });
    b.mms.forEach(function (mm) { try { mm.revert(); } catch (e) {} });
    b.sts.forEach(function (st) { try { st.kill(true); } catch (e) {} });
    b.tweens.forEach(function (t) { try { t.kill(); } catch (e) {} });
    delete REG[sid];
  }

  /* ══════════════════════════════════════════════════════════════════════
     SHARED HELPERS
     ══════════════════════════════════════════════════════════════════════ */
  function splitChars(el) {
    if (HAS_SPLIT) {
      try { var s = new SplitText(el, { type: "chars" }); return s.chars; } catch (e) {}
    }
    var txt = el.textContent, frag = document.createDocumentFragment(), out = [];
    el.textContent = "";
    for (var i = 0; i < txt.length; i++) {
      var sp = document.createElement("span");
      sp.style.display = "inline-block";
      sp.textContent = txt[i] === " " ? " " : txt[i];
      frag.appendChild(sp); out.push(sp);
    }
    el.appendChild(frag); return out;
  }

  /* ---- Cursor (one global instance; sections only attach their own nodes) ---- */
  function attachCur(root) {
    var cur = $(".cur");
    if (IS_TOUCH || !cur) return;
    $$("a,button,input,.room-card,.offer-card,.faq-q,.hrow,.list-legend span", root).forEach(function (el) {
      if (el.__cur) return; el.__cur = true;
      el.addEventListener("mouseenter", function () { var c = $(".cur"); if (c) c.classList.add("on"); });
      el.addEventListener("mouseleave", function () { var c = $(".cur"); if (c) c.classList.remove("on"); });
    });
  }
  window.__attachCur = attachCur;

  /* ══════════════════════════════════════════════════════════════════════
     SHARED STATE — cross-section bindings
     The ON THE LIST counter and the countdown span hero / list / hours, so
     they re-query the DOM on every render instead of caching element refs.
     That is what makes them survive a section reload.
     ══════════════════════════════════════════════════════════════════════ */
  /* The ON THE LIST counter is gone. It seeded at 218 and ticked up on a timer,
     presenting an invented number as a live count in three places. Those slots
     now render the real room capacity straight from the section settings. */

  /* ---- the book -----------------------------------------------------------
     The rows are rendered by Liquid, not built here: they are the nights the
     room actually sells, so they must exist without JS and be indexable. All
     this does is type each line in as the book scrolls into view. Nothing is
     generated, nothing arrives on a timer, nothing is trimmed.

     `typeInto` returns its interval so the caller can file it under the
     section and a reload mid-type cannot leave an orphan writing into a
     detached node. */
  function typeInto(el, text, cb) {
    if (REDUCE || !HAS_GSAP) { el.textContent = text; if (cb) cb(); return null; }
    var i = 0;
    el.innerHTML = '<span class="caret"></span>';
    var caret = el.firstChild;
    var iv = setInterval(function () {
      i++;
      el.textContent = text.slice(0, i);
      el.appendChild(caret);
      if (i >= text.length) {
        clearInterval(iv);
        setTimeout(function () {
          if (caret && caret.parentNode) caret.parentNode.removeChild(caret);
          if (cb) cb();
        }, 220);
      }
    }, 34);
    return iv;
  }

  /* ══════════════════════════════════════════════════════════════════════
     PRELOADER — trap (E)
     Runs exactly once, at boot. If the editor re-injects the chrome section
     afterwards, the overlay is dismissed on sight instead of replaying.
     ══════════════════════════════════════════════════════════════════════ */
  var BOOTED = false;
  var PRELOADER_DONE = false;

  function dismissPreloader() {
    $$(".pre").forEach(function (pre) {
      if (pre.parentNode) pre.parentNode.removeChild(pre);
    });
  }

  function runPreloader(done) {
    var pre = $("#pre");
    var listEl = $("#preList");
    var stateEl = $("#preState");
    var samples = ["041 · M. LEROUX ....... <b>ARRIVED</b>", "042 · THE OKONKWO PARTY <b>EN ROUTE</b>", "043 · S. PATEL +1 ...... <b>CONFIRMED</b>"];
    if (listEl) {
      samples.forEach(function (s) { var i = document.createElement("i"); i.innerHTML = s; listEl.appendChild(i); });
    }
    var finish = function () {
      PRELOADER_DONE = true;
      revealDock();
      if (!pre) { done(); return; }
      pre.classList.add("done");
      setTimeout(function () { if (pre && pre.parentNode) pre.parentNode.removeChild(pre); done(); }, 720);
    };
    if (!HAS_GSAP || REDUCE) {
      $$(".pre-word span").forEach(function (s) { s.style.opacity = 1; s.style.transform = "none"; });
      $$("#preList i").forEach(function (s) { s.style.opacity = 1; });
      setTimeout(finish, REDUCE ? 200 : 600);
      return;
    }
    var tl = gsap.timeline({ onComplete: finish });
    tl.to("#preWord span", { opacity: 1, y: 0, duration: .5, ease: "power3.out", stagger: .10 }, 0);
    tl.to("#preList i", { opacity: 1, duration: .4, ease: "power2.out", stagger: .24 }, .45);
    if (stateEl) {
      tl.call(function () { stateEl.textContent = "CHECKING"; }, null, .85);
      tl.call(function () { stateEl.textContent = "ON THE LIST"; }, null, 1.55);
    }
    tl.to({}, { duration: .35 }, 1.7);
    // total ~2.05s, under the 2.5s cap
  }

  /* CTA dock: only shown once the intro is out of the way */
  function revealDock() {
    $$(".alia-cta-dock").forEach(function (d) { d.classList.add("revealed"); });
  }

  /* ══════════════════════════════════════════════════════════════════════
     GLOBAL SYSTEMS — created once, never per-section
     ══════════════════════════════════════════════════════════════════════ */
  var lenis = null;

  function initGlobals() {
    if (IS_TOUCH) document.body.classList.add("touch");

    /* ---- Lenis + ScrollTrigger sync (ONE instance, kept first) ---- */
    if (HAS_LENIS && HAS_GSAP && HAS_ST && !REDUCE && !lenis) {
      lenis = new Lenis({ duration: 1.1, easing: function (t) { return Math.min(1, 1.001 - Math.pow(2, -10 * t)); }, smoothWheel: true });
      lenis.on("scroll", ScrollTrigger.update);
      gsap.ticker.add(function (t) { lenis.raf(t * 1000); });
      gsap.ticker.lagSmoothing(0);
    }

    /* ---- Cursor (single rAF loop for the whole page) ---- */
    if (!IS_TOUCH) {
      var cx = window.innerWidth / 2, cy = window.innerHeight / 2, tx = cx, ty = cy;
      window.addEventListener("mousemove", function (e) {
        tx = e.clientX; ty = e.clientY;
        var dot = $(".cur-dot");
        if (dot) { dot.style.transform = "translate(" + tx + "px," + ty + "px)"; }
      }, { passive: true });
      (function loop() {
        cx = lerp(cx, tx, .18); cy = lerp(cy, ty, .18);
        var cur = $(".cur");
        if (cur) { cur.style.transform = "translate(" + cx + "px," + cy + "px)"; }
        requestAnimationFrame(loop);
      })();
    }

    /* ---- Nav shrink (re-queries #nav so a nav reload cannot orphan it) ---- */
    var onNav = function () {
      var nav = $("#nav");
      if (nav) nav.classList.toggle("shrunk", window.scrollY > 60);
    };
    onNav();
    window.addEventListener("scroll", onNav, { passive: true });

    /* ---- Countdown (doors + last call), one interval for hero + hours ---- */
    initCountdown();

    /* ---- one delegated listener owns every Corporate button on the site ---- */
    document.addEventListener("click", function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var trigger = t.closest("[data-open-corporate]");
      if (!trigger) return;
      e.preventDefault();
      openCorporate();
    });

    /* ---- fonts ready / load refreshes ---- */
    if (HAS_ST && document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { ScrollTrigger.refresh(); });
    }
    if (HAS_ST) {
      window.addEventListener("load", function () { ScrollTrigger.refresh(); });
    }

    /* dock safety net if the preloader markup is absent entirely */
    setTimeout(function () { if (!PRELOADER_DONE) revealDock(); }, 6000);
  }

  /* ---- COUNTDOWN (doors + last call) — global, queries fresh every tick ---- */
  var DAYNAMES = ["SUNDAY", "MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY"];
  function windows(from) {
    var list = [];
    for (var d = 0; d < 9; d++) {
      var day = new Date(from.getFullYear(), from.getMonth(), from.getDate() + d, 0, 0, 0, 0);
      var dow = day.getDay();
      if (dow === 4 || dow === 5 || dow === 6) {
        var open = new Date(day); open.setHours(19, 0, 0, 0);
        var close = new Date(open); close.setHours(open.getHours() + (dow === 4 ? 6 : 7));
        list.push({ open: open, close: close, dow: dow });
      }
    }
    return list;
  }
  function nightState(now) {
    var wins = windows(new Date(now.getTime() - 24 * 3600 * 1000));
    for (var i = 0; i < wins.length; i++) {
      if (now >= wins[i].open && now < wins[i].close) return { open: true, target: wins[i].close, dow: wins[i].dow };
    }
    var future = windows(now);
    for (var j = 0; j < future.length; j++) {
      if (future[j].open > now) return { open: false, target: future[j].open, dow: future[j].dow };
    }
    return { open: false, target: future.length ? future[0].open : now, dow: 4 };
  }
  function countdownTick() {
    var now = new Date();
    var st = nightState(now);
    var diff = Math.max(0, (st.target - now) / 1000);
    var days = Math.floor(diff / 86400);
    var h = Math.floor(diff / 3600), m = Math.floor((diff % 3600) / 60), sec = Math.floor(diff % 60);

    /* The room is closed Sunday to Wednesday, so on a Sunday the wait to the
       next 7PM is over 100 hours. A three-digit hour breaks a clock built for
       two digits — it overflowed the card and shoved the hours list off the
       grid. Past 24h the readout rolls into days so every group stays two
       digits and the unit label says which three units are on screen. */
    var a, b, c, unit;
    if (days >= 1) { a = pad2(days); b = pad2(h % 24); c = pad2(m); unit = "D · H · M"; }
    else           { a = pad2(h);    b = pad2(m);      c = pad2(sec); unit = "H · M · S"; }

    var heroDoors = $("#heroDoors"), heroDoorsK = $("#heroDoorsK"), heroOpen = $("#heroOpen"), heroDate = $("#heroDate");
    var hrH = $("#hrH"), hrM = $("#hrM"), hrS = $("#hrS"), hrKey = $("#hrKey"), hrState = $("#hrState"), hrUnit = $("#hrUnit");
    if (heroDoors) heroDoors.textContent = a + ":" + b + ":" + c;
    if (heroDoorsK) heroDoorsK.textContent = st.open ? "Last Call In" : "Doors In";
    if (heroOpen) heroOpen.textContent = st.open ? "OPEN" : "CLOSED";
    if (heroDate) heroDate.textContent = DAYNAMES[st.dow].slice(0, 3);
    if (hrH) { hrH.textContent = a; hrM.textContent = b; hrS.textContent = c; }
    if (hrUnit) hrUnit.textContent = unit;
    if (hrKey) hrKey.textContent = st.open ? "LAST CALL IN" : "NEXT DOORS IN";
    if (hrState) hrState.innerHTML = (st.open ? "ON THE FLOOR NOW · " : "SEE YOU AT SEVEN · ") + "<b>" + DAYNAMES[st.dow] + "</b>";
  }
  var countdownIv = null;
  function initCountdown() {
    countdownTick();
    if (!countdownIv) countdownIv = setInterval(countdownTick, 1000);
  }

  /* ══════════════════════════════════════════════════════════════════════
     GENERIC PER-SECTION TREATMENTS
     ══════════════════════════════════════════════════════════════════════ */
  function initGeneric(root, sid) {
    attachCur(root);

    if (HAS_GSAP && HAS_ST && !REDUCE) {
      // line-mask rise
      $$("[data-rise]", root).forEach(function (el) {
        el.style.visibility = "visible";
        var chars = splitChars(el);
        gsap.set(chars, { yPercent: 110 });
        own(sid, gsap.to(chars, { yPercent: 0, duration: 1, ease: "power4.out", stagger: .028,
          scrollTrigger: { trigger: el, start: "top 88%" } }));
      });
      // frequency headlines (sine displacement settle)
      $$("[data-freq]", root).forEach(function (el) {
        var chars = splitChars(el);
        gsap.set(chars, { opacity: 0, yPercent: function (i) { return 60 * Math.sin(i * 0.5); } });
        own(sid, gsap.to(chars, { opacity: 1, yPercent: 0, duration: 1.15, ease: "power3.out", stagger: .012,
          scrollTrigger: { trigger: el, start: "top 84%" } }));
      });
      // generic reveals
      $$(".reveal", root).forEach(function (el) {
        own(sid, gsap.to(el, { opacity: 1, y: 0, duration: .9, ease: "power3.out",
          scrollTrigger: { trigger: el, start: "top 90%" } }));
      });
    } else {
      $$("[data-rise]", root).forEach(function (el) { el.style.visibility = "visible"; });
      $$(".reveal", root).forEach(function (el) { el.style.opacity = 1; el.style.transform = "none"; });
    }
  }

  /* ══════════════════════════════════════════════════════════════════════
     CONVERSION LAYER — the three doors, the "?" panel, the lead pipeline

     Every [data-open-corporate] button on the site opens ONE dialog. The
     buttons live in the nav, the CTA bands, the corporate section and the
     reserve fine print, so the trigger is delegated at document level rather
     than bound per section: that way the theme editor can reload any of those
     sections and the buttons keep working with nothing to rebind.
     ══════════════════════════════════════════════════════════════════════ */
  /* Config is emitted inline in <head> by layout/theme.liquid, so it is defined
     before this deferred script runs. */
  var CFG = window.ALIA_CFG || {};
  var LEAD = {
    endpoint: CFG.endpoint || "",
    site: CFG.site || "",
    phone: CFG.phoneDisplay || ""
  };
  /* no endpoint means the form genuinely cannot deliver */
  var DEMO = !LEAD.endpoint;

  function setHelper(open) {
    var helper = $("#helper"), fab = $("#fab");
    if (!helper || !fab) return;
    helper.hidden = !open;
    fab.setAttribute("aria-expanded", String(open));
    fab.textContent = open ? "✕" : "?";
  }

  /* ── session guard ────────────────────────────────────────────────────────
     A guest who already sent a request and reopens the form should not be
     handed a blank one — they either think it failed and send a duplicate, or
     they bounce. sessionStorage, not localStorage: the memory is meant to last
     the visit, not follow them back next week when the answer has moved on. */
  var SENT_KEY = "alia_corp_sent";
  function rememberSent(p) {
    try {
      window.sessionStorage.setItem(SENT_KEY, JSON.stringify({
        name: p.data.Name || "",
        guests: p.data.Guests || "",
        date: p.data["Preferred date"] || ""
      }));
    } catch (e) {}
  }
  function forgetSent() { try { window.sessionStorage.removeItem(SENT_KEY); } catch (e) {} }
  function lastSent() {
    try { return JSON.parse(window.sessionStorage.getItem(SENT_KEY) || "null"); }
    catch (e) { return null; }
  }

  function resetDialog() {
    var form = $("#corp-form"), done = $("#corp-done");
    if (form) { form.hidden = false; form.reset(); $$(".field", form).forEach(function (f) {
      f.classList.remove("is-filled", "is-invalid");
      f.removeAttribute("data-touched");
    }); }
    if (done) done.hidden = true;
    ["#corp-title", "#corp-sub"].forEach(function (sel) {
      var el = $(sel);
      if (el && el.getAttribute("data-original")) el.textContent = el.getAttribute("data-original");
    });
    var other = $("#f-other-wrap");
    if (other) other.hidden = true;
    var oi = $("#f-other");
    if (oi) oi.removeAttribute("required");
  }

  function openCorporate() {
    var dlg = $("#corp");
    if (!dlg) return;
    setHelper(false);

    var prev = lastSent();
    if (prev) showReturning(prev);
    else resetDialog();

    if (typeof dlg.showModal === "function") { if (!dlg.open) dlg.showModal(); }
    else { dlg.setAttribute("open", ""); }

    if (!prev) {
      var first = $("#f-name");
      if (first) first.focus({ preventScroll: true });
    } else {
      var again = $("#corp-again");
      if (again) again.focus({ preventScroll: true });
    }
  }

  /* shown instead of a blank form when this session already sent one */
  function showReturning(prev) {
    var form = $("#corp-form"), done = $("#corp-done"), root = $("#corp");
    if (!done) return;
    if (form) form.hidden = true;
    done.hidden = false;

    var title = $("#corp-title"), sub = $("#corp-sub");
    if (title) title.textContent = "Request received";
    if (sub) sub.textContent = "One of the events team is already on it.";

    var first = (prev.name || "").trim().split(/\s+/)[0];
    var dt = $("#done-title");
    if (dt) dt.textContent = first ? "You are in the book, " + first + "." : "You are in the book.";

    var lede = $("#done-lede");
    if (lede) {
      var detail = prev.guests && prev.date
        ? " for <b>" + prev.guests + " guests</b> on <b>" + niceDate(prev.date) + "</b>"
        : "";
      lede.innerHTML = "We already have your request" + detail +
        ". There is nothing more to do — the events team will come back to you. " +
        "If the night has changed, send another and we will use the newer one.";
    }
    var summary = $("#corp-summary");
    if (summary) summary.innerHTML = "";
    var fine = $("#done-fine");
    if (fine) fine.textContent = "";
    stampSeal(root, true);
  }

  /* the wax seal, pressed onto the confirmation */
  function stampSeal(root, instant) {
    var seal = $("#corpSeal", root || document);
    if (!seal) return;
    if (!HAS_GSAP || REDUCE || instant) {
      seal.style.opacity = 1;
      seal.style.transform = "rotate(-6deg)";
      return;
    }
    gsap.set(seal, { opacity: 0, scale: 1.55, rotate: -18 });
    gsap.to(seal, { opacity: 1, scale: 1, rotate: -8, duration: .5, ease: "back.out(2.2)" });
    gsap.to(seal, { rotate: -6, duration: .9, ease: "elastic.out(1,0.4)", delay: .5 });
  }

  /* the date is stored ISO but read back the way a person says it out loud */
  function niceDate(iso) {
    try {
      var p = String(iso).split("-");
      return new Date(p[0], p[1] - 1, p[2]).toLocaleDateString("en-CA",
        { weekday: "long", month: "long", day: "numeric", year: "numeric" });
    } catch (err) { return iso; }
  }

  /* ── the sheet contract ──────────────────────────────────────────────────
     Leads sheet columns:
       Received | Site | Page | Name | Company | Email | Phone | Event type |
       Event detail | Guests | Preferred date | Budget per head | Notes | Status

     The Apps Script matches columns by HEADER TEXT. "Event Type" is a different
     column from "Event type" as far as it is concerned, and a mismatch fails
     silently: no browser error, no sheet error, the column just goes quiet.
     The name="" attributes in enquiry.liquid are the contract — do not rename.

     "Received" is stamped server side and "Status" is filled by hand, so
     neither is sent. Empty fields are skipped rather than sent as blanks.
     ──────────────────────────────────────────────────────────────────────── */
  function collectLead(form) {
    var data = {}, rows = [];
    Array.prototype.forEach.call(form.elements, function (el) {
      if (!el.name || !el.value) return;   /* emptiness is `required`'s job */
      data[el.name] = el.value;
      rows.push({ k: el.name, v: el.name === "Preferred date" ? niceDate(el.value) : el.value });
    });
    /* plumbing, added in JS rather than as form inputs */
    data.Site = LEAD.site;
    data.Page = window.location.href;
    return { data: data, rows: rows };
  }

  /* ── delivery ────────────────────────────────────────────────────────────
     POSTs to the Google Apps Script Web App set in Theme settings > ALIA leads.
     The body goes out as text/plain, which avoids a CORS preflight that Apps
     Script rejects outright. Do not "fix" that to application/json.

     Neither branch proves the row was written: the response carries no
     readable headers either way. The sheet is the only proof of delivery.

     NO ENDPOINT SET => the lead is NOT delivered, the guest is told so and
     given the phone, and a console warning fires. The only real fix is pasting
     the /exec URL into theme settings.
     ──────────────────────────────────────────────────────────────────────── */
  function deliverLead(payload) {
    if (DEMO) {
      if (window.console) {
        console.warn("[alia] No lead endpoint configured (Theme settings > ALIA leads). " +
                     "This enquiry was NOT delivered.");
      }
      return Promise.resolve(false);
    }
    /* text/plain avoids a CORS preflight, which Apps Script endpoints reject.
       Do not "fix" this to application/json. */
    return fetch(LEAD.endpoint, {
      method: "POST",
      headers: { "Content-Type": "text/plain;charset=utf-8" },
      body: JSON.stringify(payload.data)
    }).then(
      function () { return true; },
      /* Only a genuine network/CORS failure reaches here. The response carries
         no readable headers either way, so neither branch proves the row was
         written — the sheet is the only proof of delivery. */
      function () { return false; }
    );
  }

  function showConfirmation(root, form, payload, delivered) {
    var summary = $("#corp-summary", root);
    if (summary) {
      summary.innerHTML = "";
      payload.rows.forEach(function (r) {
        var row = document.createElement("div");
        var dt = document.createElement("dt"); dt.textContent = r.k;
        var dd = document.createElement("dd"); dd.textContent = r.v;
        row.appendChild(dt); row.appendChild(dd);
        summary.appendChild(row);
      });
    }

    var first = (payload.data.Name || "").trim().split(/\s+/)[0];
    var guests = payload.data.Guests || "";
    var pretty = niceDate(payload.data["Preferred date"] || "");

    /* the header has to stop selling the form once the form is done.
       Nothing here may promise a response time or a provisional hold: neither
       is confirmed by the client, so neither gets published. */
    var title = $("#corp-title", root), sub = $("#corp-sub", root);
    if (title) title.textContent = delivered ? "Request received" : "One more step";
    if (sub) sub.textContent = delivered
      ? "The events team has it."
      : "We could not send that from here.";

    var doneTitle = $("#done-title", root);
    if (doneTitle) {
      doneTitle.textContent = delivered
        ? (first ? "Thank you, " + first + "." : "Thank you.")
        : "Give us a call.";
    }

    var lede = $("#done-lede", root);
    if (lede) {
      lede.innerHTML = delivered
        ? "Your request for <b>" + guests + " guests</b> on <b>" + pretty + "</b> is with our events team."
        : "Your request for <b>" + guests + " guests</b> on <b>" + pretty + "</b> did not reach us. " +
          "Call the room on the number below and we will take the details down.";
    }
    var fine = $("#done-fine", root);
    if (fine) {
      fine.textContent = delivered
        ? "The events team will be in touch about the date."
        : "Nothing was sent, so nothing is lost — the call picks up exactly where this left off.";
    }

    form.hidden = true;
    var done = $("#corp-done", root);
    if (done) { done.hidden = false; done.scrollIntoView({ block: "nearest" }); }
    /* the seal only presses on a real send, never on a failure */
    if (delivered) stampSeal(root, false);
  }

  /* ══════════════════════════════════════════════════════════════════════
     SECTION MODULES — keyed by data-section-type
     ══════════════════════════════════════════════════════════════════════ */
  var MODULES = {

    /* ---- chrome: grain, ambient, cursor nodes, scroll beam, preloader ---- */
    chrome: function (root, sid) {
      if (PRELOADER_DONE) dismissPreloader();

      var beam = $("#beamFill", root);
      if (beam && HAS_GSAP && HAS_ST) {
        own(sid, gsap.to(beam, { scaleX: 1, ease: "none",
          scrollTrigger: { trigger: document.documentElement, start: "top top", end: "bottom bottom", scrub: true } }));
      } else if (beam) {
        ownListener(sid, window, "scroll", function () {
          var h = document.documentElement.scrollHeight - window.innerHeight;
          beam.style.transform = "scaleX(" + (h > 0 ? window.scrollY / h : 0) + ")";
        }, { passive: true });
      }
    },

    /* ---- nav + mega menu ---- */
    nav: function (root, sid) {
      var nav = $("#nav", root);
      if (nav) nav.classList.toggle("shrunk", window.scrollY > 60);

      var btn = $("#megaBtn", root);
      var panel = $("#megaPanel", root);
      if (!btn || !panel) return;

      function setMega(open) {
        panel.hidden = !open;
        btn.setAttribute("aria-expanded", String(open));
        btn.classList.toggle("is-open", open);
        document.body.classList.toggle("mega-open", open);
      }
      /* the panel must never survive its own section being reloaded or
         reordered in the editor, or it hangs over the page with no trigger */
      ownUndo(sid, function () { document.body.classList.remove("mega-open"); });

      ownListener(sid, btn, "click", function (e) {
        e.stopPropagation();
        setMega(panel.hidden);
      });
      ownListener(sid, document, "click", function (e) {
        if (panel.hidden) return;
        if (!panel.contains(e.target) && !btn.contains(e.target)) setMega(false);
      });
      ownListener(sid, document, "keydown", function (e) {
        if (e.key === "Escape" && !panel.hidden) { setMega(false); btn.focus(); }
      });
      /* following a link inside the panel must close it: the targets are
         same-page anchors, so no navigation happens to close it for us */
      ownListener(sid, panel, "click", function (e) {
        var a = e.target && e.target.closest ? e.target.closest("a") : null;
        if (a) setMega(false);
      });
      ownListener(sid, window, "resize", function () { if (!panel.hidden) setMega(false); });
    },

    /* ---- hero: intro timeline + IO-gated ledger canvas ---- */
    hero: function (root, sid) {
      if (HAS_GSAP && !REDUCE) {
        var ht = $("#heroTitle", root);
        var hchars = [];
        if (ht) {
          $$(".ln", ht).forEach(function (ln) {
            var cs = splitChars(ln); cs.forEach(function (c) { c.classList.add("ch"); hchars.push(c); });
          });
        }
        var tl = gsap.timeline({ delay: .1 });
        tl.from(hchars, { yPercent: 118, opacity: 0, duration: 1.1, ease: "power4.out", stagger: .055 }, 0);
        tl.to("#heroEye", { opacity: 1, duration: .6, ease: "power2.out" }, .2);
        tl.to("#heroSub", { opacity: 1, y: 0, duration: .8, ease: "power3.out" }, .55);
        tl.to("#heroFoot", { opacity: 1, y: 0, duration: .8, ease: "power3.out" }, .75);
        tl.to("#heroDoorCards", { opacity: 1, y: 0, duration: .8, ease: "power3.out" }, .9);
        tl.to("#heroCue", { opacity: 1, duration: .6, ease: "power2.out" }, 1.1);
        own(sid, tl);
      } else {
        ["#heroEye", "#heroSub", "#heroFoot", "#heroDoorCards", "#heroCue"].forEach(function (s) { var e = $(s, root); if (e) e.style.opacity = 1; });
      }

      /* HERO LEDGER CANVAS (faint scrolling names), IntersectionObserver-gated */
      (function heroLedger() {
        var cv = $("#heroCanvas", root); if (!cv) return;
        var ctx = cv.getContext("2d");
        var W = 0, H = 0, running = false, raf = 0, t0 = performance.now();
        var lines = [];
        var pool = ledgerPool();
        function size() {
          var r = cv.getBoundingClientRect();
          cv.width = Math.max(1, Math.round(r.width * DPR));
          cv.height = Math.max(1, Math.round(r.height * DPR));
          W = cv.width; H = cv.height;
          var rows = Math.ceil(H / (26 * DPR)) + 2;
          lines = [];
          for (var i = 0; i < rows; i++) {
            lines.push({ y: i * 26 * DPR, txt: pad2(30 + i) + "   " + pool[(i * 3) % pool.length], a: 0.05 + 0.09 * ((i * 7) % 5) / 5 });
          }
        }
        size();
        function draw(now) {
          var t = (now - t0) / 1000;
          ctx.clearRect(0, 0, W, H);
          ctx.font = (12 * DPR) + "px 'Chivo Mono', monospace";
          ctx.textBaseline = "middle";
          var drift = (t * 10 * DPR) % (26 * DPR);
          for (var i = 0; i < lines.length; i++) {
            var ln = lines[i];
            var y = ((ln.y - drift) % (H + 52 * DPR)); if (y < 0) y += H + 52 * DPR;
            ctx.fillStyle = "rgba(198,136,78," + ln.a + ")";
            ctx.fillText(ln.txt, 24 * DPR, y);
          }
          if (running) raf = requestAnimationFrame(draw);
        }
        function start() { if (running) return; running = true; t0 = performance.now() - 0; raf = requestAnimationFrame(draw); }
        function stop() { running = false; if (raf) cancelAnimationFrame(raf); }
        ownUndo(sid, stop);
        ownListener(sid, window, "resize", function () { size(); if (REDUCE) draw(performance.now()); });
        if (REDUCE) { draw(performance.now()); return; }
        if ("IntersectionObserver" in window) {
          var io = new IntersectionObserver(function (en) { en.forEach(function (e) { e.isIntersecting ? start() : stop(); }); }, { threshold: .02 });
          io.observe(cv);
          ownIO(sid, io);
        } else start();
      })();
    },

    /* ---- premise: generic only ---- */
    premise: function () {},

    /* ---- the book: type the bookable nights in as it scrolls into view ---- */
    list: function (root, sid) {
      var ledgerRows = $("#ledgerRows", root);
      if (!ledgerRows) return;
      attachCur(ledgerRows);

      var rows = $$(".lrow", ledgerRows);
      if (!rows.length) return;

      /* Liquid already rendered the text, so reduced motion and a failed CDN
         both leave a complete, readable book. Only enhance past that. */
      if (REDUCE || !HAS_GSAP) return;

      var written = false;
      function writeBook() {
        if (written) return;
        written = true;
        rows.forEach(function (row, i) {
          var nameEl = $(".l-name", row);
          if (!nameEl) return;
          var text = nameEl.textContent;
          nameEl.textContent = "";
          /* each line starts a beat after the one above, so the book reads as
             it is being written rather than all at once */
          ownTimer(sid, setTimeout(function () {
            var iv = typeInto(nameEl, text);
            if (iv) ownTimer(sid, iv);
          }, i * 220));
        });
        own(sid, gsap.from(rows, { opacity: 0, x: -10, duration: .5, ease: "power3.out", stagger: .09 }));
      }
      /* if the section is torn down mid-write, the rows must not be left blank */
      ownUndo(sid, function () {
        rows.forEach(function (row) {
          var nameEl = $(".l-name", row);
          if (nameEl && !nameEl.textContent) nameEl.textContent = nameEl.getAttribute("data-text") || "";
        });
      });
      rows.forEach(function (row) {
        var nameEl = $(".l-name", row);
        if (nameEl) nameEl.setAttribute("data-text", nameEl.textContent);
      });

      if ("IntersectionObserver" in window) {
        var lio = new IntersectionObserver(function (en) {
          en.forEach(function (e) { if (e.isIntersecting) { writeBook(); lio.disconnect(); } });
        }, { threshold: .18 });
        lio.observe($("#ledger", root) || ledgerRows);
        ownIO(sid, lio);
      } else {
        writeBook();
      }
    },

    /* ---- threshold: the pinned velvet rope ---- */
    threshold: function (root, sid) {
      var stage = $("#thStage", root); if (!stage) return;
      var hudV = $("#thHudV", root), hudBar = $("#thHudBar", root);
      var ropeGroup = $("#ropeGroup", root), hook = $("#hook", root),
          sceneWrap = $("#thSceneWrap", root), light = $("#thLight", root),
          tag = $("#thTag", root), offer = $("#thOffer", root);

      /* Reduced motion, or no ScrollTrigger: the rope is already open and the
         offer is already up. The scroll cue MUST go with it — leaving it on
         reads as an instruction to do something that has already happened. */
      function staticOpen() {
        if (window.gsap) {
          if (ropeGroup) gsap.set(ropeGroup, { rotation: 90, svgOrigin: "300 300" });
          if (sceneWrap) gsap.set(sceneWrap, { opacity: .16, scale: 1.15 });
          if (light) gsap.set(light, { opacity: .7, scale: 1 });
          if (offer) gsap.set(offer, { opacity: 1, y: 0 });
          if (tag) gsap.set(tag, { opacity: 0 });
        } else {
          if (offer) offer.style.opacity = 1;
          if (tag) tag.style.opacity = 0;
        }
        if (hudV) hudV.textContent = "PAST THE ROPE";
      }

      if (!HAS_GSAP || !HAS_ST || REDUCE) { staticOpen(); return; }

      var mm = gsap.matchMedia();
      ownMM(sid, mm);

      mm.add("(min-width: 641px)", function () {
        if (ropeGroup) gsap.set(ropeGroup, { rotation: 0, svgOrigin: "300 300" });
        if (offer) gsap.set(offer, { opacity: 0, y: 60 });
        if (light) gsap.set(light, { opacity: 0, scale: .3 });
        if (sceneWrap) gsap.set(sceneWrap, { opacity: 1, scale: 1 });

        var mtl = gsap.timeline({
          scrollTrigger: {
            trigger: root, start: "top top", end: "+=230%",
            pin: stage, scrub: .7, anticipatePin: 1,
            onUpdate: function (s) {
              var p = s.progress;
              if (hudBar) hudBar.style.transform = "scaleX(" + p + ")";
              if (hudV) {
                hudV.textContent = p < 0.16 ? "ROPE CLOSED" : (p < 0.5 ? "UNHOOKING" : (p < 0.62 ? "ROPE OPEN" : "PAST THE ROPE"));
              }
            }
          }
        });
        // 1. hook releases
        mtl.to(hook, { rotation: -42, transformOrigin: "left bottom", duration: .4, ease: "power2.out" }, 0);
        // 2. rope swings open on the left pivot with a weighted, damped settle
        mtl.to(ropeGroup, { rotation: 99, svgOrigin: "300 300", duration: 1.0, ease: "power1.in" }, .25);
        mtl.to(ropeGroup, { rotation: 84, svgOrigin: "300 300", duration: .42, ease: "power2.out" });
        mtl.to(ropeGroup, { rotation: 93, svgOrigin: "300 300", duration: .32, ease: "sine.inOut" });
        mtl.to(ropeGroup, { rotation: 90, svgOrigin: "300 300", duration: .42, ease: "sine.out" });
        // 3. camera passes through the threshold into warm light
        mtl.to(sceneWrap, { scale: 2.7, opacity: 0, duration: 1.5, ease: "power2.in" }, 1.85);
        mtl.to(light, { opacity: 1, scale: 1.25, duration: 1.5, ease: "power2.out" }, 1.85);
        mtl.to(tag, { opacity: 0, y: -30, duration: .6, ease: "power2.in" }, 1.85);
        mtl.fromTo(offer, { opacity: 0, y: 60 }, { opacity: 1, y: 0, duration: 1.0, ease: "power3.out" }, 2.5);

        return function () {
          // cleanup on breakpoint change
          if (mtl.scrollTrigger) mtl.scrollTrigger.kill(true);
          mtl.kill();
        };
      });

      /* ── mobile ──────────────────────────────────────────────────────────
         This used to call staticOpen(), which is not a fallback so much as a
         surrender: the rope arrived already open, the light already on and the
         offer already up, all stacked on one screen, with the tag still
         reading SCROLL THROUGH THE ROPE underneath an open rope.

         It plays properly now — the same choreography, just not scrubbed. No
         pin and no scrub on a phone: pinning a 230% scrub is the expensive,
         janky part, and it is what the original was avoiding. A one-shot
         timeline on enter keeps the set piece and costs almost nothing. */
      mm.add("(max-width: 640px)", function () {
        if (!HAS_ST) { staticOpen(); return function () {}; }

        if (ropeGroup) gsap.set(ropeGroup, { rotation: 0, svgOrigin: "300 300" });
        if (offer) gsap.set(offer, { opacity: 0, y: 40 });
        if (light) gsap.set(light, { opacity: 0, scale: .4 });
        if (sceneWrap) gsap.set(sceneWrap, { opacity: 1, scale: 1 });
        if (tag) gsap.set(tag, { opacity: 1, y: 0 });

        var mtl = gsap.timeline({
          scrollTrigger: { trigger: root, start: "top 55%", once: true }
        });
        mtl.to(hook, { rotation: -42, transformOrigin: "left bottom", duration: .45, ease: "power2.out" }, 0);
        mtl.to(ropeGroup, { rotation: 99, svgOrigin: "300 300", duration: .9, ease: "power1.in" }, .3);
        mtl.to(ropeGroup, { rotation: 84, svgOrigin: "300 300", duration: .38, ease: "power2.out" });
        mtl.to(ropeGroup, { rotation: 90, svgOrigin: "300 300", duration: .4, ease: "sine.out" });
        /* the cue has to leave before the offer lands on top of it */
        mtl.to(tag, { opacity: 0, y: -20, duration: .4, ease: "power2.in" }, "-=.55");
        /* the scene drops well back rather than fading to nothing, so the rope
           reads as a backdrop instead of muddying the copy over it */
        mtl.to(sceneWrap, { opacity: .16, scale: 1.18, duration: .9, ease: "power2.inOut" }, "-=.3");
        mtl.to(light, { opacity: .7, scale: 1, duration: .9, ease: "power2.out" }, "<");
        mtl.fromTo(offer, { opacity: 0, y: 40 }, { opacity: 1, y: 0, duration: .7, ease: "power3.out" }, "-=.4");

        return function () {
          if (mtl.scrollTrigger) mtl.scrollTrigger.kill(true);
          mtl.kill();
        };
      });
    },

    /* ---- room: bento card batch ---- */
    room: function (root, sid) {
      if (HAS_GSAP && HAS_ST && !REDUCE) {
        var cards = $$(".room-card", root);
        if (cards.length) {
          ScrollTrigger.batch(cards, {
            start: "top 90%",
            onEnter: function (els) { own(sid, gsap.to(els, { opacity: 1, y: 0, duration: .8, ease: "power3.out", stagger: .08 })); }
          }).forEach(function (st) { ownST(sid, st); });
        }
      }
    },

    /* ---- hours: badge tonight's row (the clock itself is global) ---- */
    hours: function (root, sid) {
      var todayDow = new Date().getDay();
      $$(".hrow", root).forEach(function (r) {
        if (String(todayDow) === r.getAttribute("data-day") && !$(".hr-badge", r)) {
          r.classList.add("tonight");
          var b = document.createElement("span");
          b.className = "hr-badge";
          b.textContent = "TONIGHT";
          var day = $(".hr-day", r);
          if (day) day.appendChild(b);
        }
      });
      countdownTick();
    },

    /* ---- offer: table cards batch ---- */
    offer: function (root, sid) {
      if (HAS_GSAP && HAS_ST && !REDUCE) {
        var cards = $$(".offer-card", root);
        if (cards.length) {
          ScrollTrigger.batch(cards, {
            start: "top 88%",
            onEnter: function (els) { own(sid, gsap.to(els, { opacity: 1, y: 0, duration: .8, ease: "power3.out", stagger: .1 })); }
          }).forEach(function (st) { ownST(sid, st); });
        }
      }
    },

    /* ---- arc of the night ---- */
    arc: function (root, sid) {
      var rows = $$(".arc-row", root);
      // build heat bars per row from a rhythm curve
      rows.forEach(function (row) {
        var heat = parseFloat(row.getAttribute("data-heat") || "0.4");
        var wrap = $(".ar-heat", row); if (!wrap) return;
        if (wrap.firstChild) return; // already built (guards a re-init)
        for (var i = 0; i < 14; i++) {
          var b = document.createElement("i");
          var h = 6 + Math.abs(Math.sin(i * 0.6 + heat * 4)) * (6 + heat * 26);
          b.style.height = h + "px";
          b.style.opacity = (0.4 + heat * 0.55).toFixed(2);
          wrap.appendChild(b);
        }
      });
      if (HAS_GSAP && HAS_ST && !REDUCE) {
        rows.forEach(function (row) {
          own(sid, gsap.to(row, { opacity: 1, y: 0, duration: .8, ease: "power3.out",
            scrollTrigger: { trigger: row, start: "top 88%" } }));
          var bars = $$(".ar-heat i", row);
          own(sid, gsap.from(bars, { scaleY: 0, transformOrigin: "bottom", duration: .7, ease: "power2.out", stagger: .02,
            scrollTrigger: { trigger: row, start: "top 86%" } }));
        });
        var prog = $("#arcProgress", root);
        var trackEl = $("#arcTrack", root);
        if (prog && trackEl) {
          own(sid, gsap.to(prog, { scaleX: 1, ease: "none",
            scrollTrigger: { trigger: trackEl, start: "top 80%", end: "bottom 60%", scrub: .6 } }));
        }
      } else {
        rows.forEach(function (row) { row.style.opacity = 1; row.style.transform = "none"; });
        var p = $("#arcProgress", root); if (p) p.style.transform = "scaleX(1)";
      }
    },

    /* ---- quote: generic only ---- */
    quote: function () {},

    /* ---- faq accordion ---- */
    faq: function (root, sid) {
      $$(".faq-item", root).forEach(function (item) {
        var q = item.querySelector(".faq-q"), a = item.querySelector(".faq-a");
        if (!q || !a) return;
        ownListener(sid, q, "click", function () {
          var open = item.classList.contains("open");
          $$(".faq-item.open", root).forEach(function (o) {
            if (o !== item) {
              o.classList.remove("open");
              var oa = o.querySelector(".faq-a");
              if (HAS_GSAP && !REDUCE) gsap.to(oa, { height: 0, duration: .4, ease: "power2.inOut" });
              else oa.style.height = "0px";
            }
          });
          if (open) {
            item.classList.remove("open");
            if (HAS_GSAP && !REDUCE) gsap.to(a, { height: 0, duration: .4, ease: "power2.inOut" });
            else a.style.height = "0px";
          } else {
            item.classList.add("open");
            var target = a.scrollHeight;
            if (HAS_GSAP && !REDUCE) gsap.fromTo(a, { height: 0 }, { height: target, duration: .5, ease: "power3.out", onComplete: function () { a.style.height = "auto"; } });
            else a.style.height = "auto";
          }
        });
      });
    },

    /* ---- reserve: headline char cascade ---- */
    reserve: function (root, sid) {
      if (HAS_GSAP && HAS_ST && !REDUCE) {
        var rz = $("#rzTitle", root);
        if (rz) {
          var rc = splitChars(rz);
          gsap.set(rc, { yPercent: 120, opacity: 0 });
          own(sid, gsap.to(rc, { yPercent: 0, opacity: 1, duration: 1.1, ease: "power4.out", stagger: .04,
            scrollTrigger: { trigger: rz, start: "top 84%" } }));
        }
      }
    },

    /* ---- footer marquee ---- */
    footer: function (root, sid) {
      var track = $("#footMarq .track", root);
      if (!track || !HAS_GSAP || REDUCE) return;
      var w = track.scrollWidth / 2;
      var dur = parseFloat(root.getAttribute("data-marquee-duration"));
      if (!dur || dur <= 0) dur = 24;
      own(sid, gsap.to(track, { x: -w, duration: dur, ease: "none", repeat: -1,
        modifiers: { x: function (x) { return (parseFloat(x) % w) + "px"; } } }));
    },

    /* ---- three ways in: generic reveals, buttons are globally delegated ---- */
    ways: function (root, sid) {
      attachCur(root);
    },

    /* ---- blog index and article: nothing to animate, just cursor targets ---- */
    blogposts: function (root, sid) { attachCur(root); },
    articlebody: function (root, sid) { attachCur(root); },

    /* ---- CTA band: generic reveals only, the buttons are globally delegated ---- */
    ctarow: function (root, sid) {
      attachCur(root);
    },

    /* ---- corporate / private events ---- */
    corporate: function (root, sid) {
      attachCur(root);
      if (HAS_GSAP && HAS_ST && !REDUCE) {
        var shots = $$(".corp-shot", root);
        if (shots.length) {
          gsap.set(shots, { opacity: 0, y: 26 });
          ScrollTrigger.batch(shots, {
            start: "top 92%",
            onEnter: function (els) { own(sid, gsap.to(els, { opacity: 1, y: 0, duration: .8, ease: "power3.out", stagger: .07 })); }
          }).forEach(function (st) { ownST(sid, st); });
        }
        var items = $$(".incl-list li", root);
        if (items.length) {
          gsap.set(items, { opacity: 0, x: -14 });
          own(sid, gsap.to(items, { opacity: 1, x: 0, duration: .6, ease: "power3.out", stagger: .07,
            scrollTrigger: { trigger: root.querySelector(".incl-list"), start: "top 88%" } }));
        }
      }
    },

    /* ---- the "?" disc, its panel, and the private events dialog ---- */
    enquiry: function (root, sid) {
      attachCur(root);

      var fab = $("#fab", root);
      var helper = $("#helper", root);
      if (fab && helper) {
        ownListener(sid, fab, "click", function (e) { e.stopPropagation(); setHelper(helper.hidden); });
        ownListener(sid, document, "click", function (e) {
          if (helper.hidden) return;
          if (!helper.contains(e.target) && e.target !== fab && !fab.contains(e.target)) setHelper(false);
        });
        ownListener(sid, document, "keydown", function (e) {
          if (e.key === "Escape" && !helper.hidden) setHelper(false);
        });
      }

      var dlg = $("#corp", root);
      if (!dlg) return;

      /* the header sells the form before submit and reports after it, so the
         original copy has to be remembered for the next enquiry */
      var title = $("#corp-title", root), sub = $("#corp-sub", root);
      if (title) title.setAttribute("data-original", title.textContent);
      if (sub) sub.setAttribute("data-original", sub.textContent);

      ownListener(sid, $("#corp-x", root), "click", function () { dlg.close(); });
      var again = $("#corp-again", root);
      if (again) {
        ownListener(sid, again, "click", function () {
          forgetSent();
          resetDialog();
          var f = $("#f-name", root);
          if (f) f.focus({ preventScroll: true });
        });
      }
      ownListener(sid, dlg, "click", function (e) { if (e.target === dlg) dlg.close(); });

      var dateField = $("#f-date", root);
      if (dateField) dateField.min = new Date().toISOString().slice(0, 10);

      var form = $("#corp-form", root);
      if (!form) return;
      var fields = $$(".field", form);

      function syncField(f) {
        var c = f.querySelector("input, select, textarea");
        if (!c) return;
        f.classList.toggle("is-filled", String(c.value || "").trim() !== "");
        if (f.getAttribute("data-touched") === "1") {
          var valid = c.checkValidity();
          f.classList.toggle("is-invalid", !valid);
          c.setAttribute("aria-invalid", String(!valid));
        }
      }
      function syncAll() { fields.forEach(syncField); }

      fields.forEach(function (f) {
        var c = f.querySelector("input, select, textarea");
        if (!c) return;
        ownListener(sid, c, "input", function () { syncField(f); });
        ownListener(sid, c, "change", function () { syncField(f); });
        ownListener(sid, c, "blur", function () { f.setAttribute("data-touched", "1"); syncField(f); });
      });

      /* ── "Something else" reveals its own field ────────────────────────────
         `required` is toggled WITH visibility. A hidden control that is still
         required fails checkValidity() on something the browser cannot focus,
         so the form refuses to submit with nothing on screen explaining why. */
      var typeSel = $("#f-type", root);
      var otherWrap = $("#f-other-wrap", root);
      var otherInput = $("#f-other", root);
      if (typeSel && otherWrap && otherInput) {
        var syncOther = function () {
          var wants = /something else|other/i.test(typeSel.value || "");
          otherWrap.hidden = !wants;
          if (wants) {
            otherInput.setAttribute("required", "");
          } else {
            otherInput.removeAttribute("required");
            otherInput.value = "";
            otherWrap.classList.remove("is-invalid", "is-filled");
            otherWrap.removeAttribute("data-touched");
          }
        };
        ownListener(sid, typeSel, "change", syncOther);
        syncOther();
      }

      syncAll();

      ownListener(sid, form, "submit", function (e) {
        e.preventDefault();
        fields.forEach(function (f) { f.setAttribute("data-touched", "1"); });
        syncAll();

        if (!form.checkValidity()) {
          var bad = form.querySelector(".field.is-invalid input, .field.is-invalid select, .field.is-invalid textarea");
          if (bad) bad.focus({ preventScroll: true });
          return;
        }

        var payload = collectLead(form);
        var btn = $("#corp-submit", root);
        if (btn) { btn.disabled = true; btn.textContent = "Sending"; }

        deliverLead(payload).then(function (delivered) {
          if (btn) { btn.disabled = false; btn.textContent = "Send request"; }
          if (delivered) rememberSent(payload);
          showConfirmation(root, form, payload, delivered);
        });
      });
    }
  };

  /* ══════════════════════════════════════════════════════════════════════
     SECTION LIFECYCLE
     ══════════════════════════════════════════════════════════════════════ */
  function sectionRoots(scope) {
    var out = [];
    if (!scope) return out;
    if (scope.nodeType === 1 && scope.hasAttribute && scope.hasAttribute("data-section-type")) out.push(scope);
    out = out.concat($$("[data-section-type]", scope));
    return out;
  }

  function initSection(root) {
    if (!root || root.__aliaInited) return;
    var type = root.getAttribute("data-section-type");
    var sid = root.getAttribute("data-section-id") || type;
    root.__aliaInited = true;
    root.__aliaSid = sid;
    initGeneric(root, sid);
    var mod = MODULES[type];
    if (mod) { try { mod(root, sid); } catch (e) { if (window.console) console.warn("[alia] section " + type + " failed", e); } }
  }

  function teardownSection(root) {
    if (!root) return;
    var sid = root.__aliaSid || root.getAttribute("data-section-id") || root.getAttribute("data-section-type");
    killSection(sid);
    root.__aliaInited = false;
  }

  function initAll() {
    sectionRoots(document).forEach(initSection);
  }

  /* Theme editor hooks — trap (E) and trap (H) */
  document.addEventListener("shopify:section:load", function (e) {
    if (!BOOTED) return;
    // the preloader must never replay once the page has booted
    dismissPreloader();
    sectionRoots(e.target).forEach(function (root) {
      teardownSection(root);
      initSection(root);
    });
    // cross-section bindings rebuilt against the fresh DOM
    countdownTick();
    if (PRELOADER_DONE) revealDock();
    if (HAS_ST) ScrollTrigger.refresh();
  });

  document.addEventListener("shopify:section:unload", function (e) {
    sectionRoots(e.target).forEach(teardownSection);
    if (HAS_ST) ScrollTrigger.refresh();
  });

  document.addEventListener("shopify:section:reorder", function () {
    if (HAS_ST) ScrollTrigger.refresh();
  });

  /* ══════════════════════════════════════════════════════════════════════
     BOOT
     ══════════════════════════════════════════════════════════════════════ */
  function boot() {
    if (BOOTED) return;
    BOOTED = true;
    initGlobals();
    runPreloader(function () {
      initAll();
      if (HAS_ST) ScrollTrigger.refresh();
    });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
